import { useQuery } from "react-query";
import { getCameraTypes1 } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useCameraTypes1 = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetCameraTypes1",
    getCameraTypes1,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
